import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2fe6828"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "container",
  style: {"font-family":"'YouSheBiaoTiHei'","color":"#fff","font-size":"20px"}
}, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "chartBox",
  style: {"font-family":"'YouSheBiaoTiHei'","color":"#fff","font-size":"24px"}
}
const _hoisted_3 = { class: "leftChart" }
const _hoisted_4 = { class: "back-arrow" }
const _hoisted_5 = { style: {"margin-left":"30px","margin-top":"40px","width":"422px"} }
const _hoisted_6 = { style: {"font-size":"34px"} }
const _hoisted_7 = {
  class: "overflow2",
  style: {"font-size":"34px"}
}
const _hoisted_8 = {
  class: "overflow2",
  style: {"font-size":"34px","-webkit-line-clamp":"1"}
}
const _hoisted_9 = { class: "score-layout" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upline" }, null, -1))
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "score" }
const _hoisted_13 = { class: "score1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score2" }, "/", -1))
const _hoisted_15 = { class: "score3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "program-score" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "项目得分"),
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("div", { class: "p2" }, "项目标准分")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downline" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "参与机构总数", -1))
const _hoisted_19 = { class: "overflow2 title1" }
const _hoisted_20 = { class: "content1" }
const _hoisted_21 = {
  class: "overflow2 title2",
  style: {"-webkit-line-clamp":"1"}
}
const _hoisted_22 = { class: "score-layout-dialog" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upline" }, null, -1))
const _hoisted_24 = { class: "content" }
const _hoisted_25 = { class: "score" }
const _hoisted_26 = { class: "score1" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score2" }, "/", -1))
const _hoisted_28 = { class: "score3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "program-score" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "项目得分"),
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("div", { class: "p2" }, "项目标准分")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downline" }, null, -1))
const _hoisted_31 = { class: "content2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title3" }, "区域统计", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score-statistics" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "score-statistics-title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "score-upline" }),
    /*#__PURE__*/_createElementVNode("div", { class: "score-title" }, "得分统计"),
    /*#__PURE__*/_createElementVNode("div", { class: "score-downline" })
  ])
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-statistics" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "question-statistics-title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "question-upline" }),
    /*#__PURE__*/_createElementVNode("div", { class: "question-title" }, "问题统计"),
    /*#__PURE__*/_createElementVNode("div", { class: "question-downline" })
  ])
], -1))
const _hoisted_35 = { class: "area-body" }
const _hoisted_36 = { style: {"padding-top":"20px","display":"flex","justify-content":"space-around"} }
const _hoisted_37 = { class: "area" }
const _hoisted_38 = { class: "area-name" }
const _hoisted_39 = { class: "progressBarAll" }
const _hoisted_40 = { class: "progressBarBackground" }
const _hoisted_41 = { class: "area-score" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fen" }, "分", -1))
const _hoisted_43 = { class: "questions-num" }
const _hoisted_44 = { class: "question-num" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ge" }, "个", -1))
const _hoisted_46 = { class: "progressBarAll" }
const _hoisted_47 = { style: {"width":"100%","height":"100%"} }
const _hoisted_48 = { class: "content3" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title4" }, "表得分统计", -1))
const _hoisted_50 = { class: "buttons" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "table-standard-score" }
const _hoisted_53 = { class: "content" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upline" }, null, -1))
const _hoisted_55 = { class: "score" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "表格标准分", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downline" }, null, -1))
const _hoisted_58 = { class: "table-score-area" }
const _hoisted_59 = { style: {"padding-top":"20px","display":"flex","justify-content":"space-around"} }
const _hoisted_60 = { class: "progressBarAll" }
const _hoisted_61 = { class: "progressBarBackground" }
const _hoisted_62 = { class: "area-name" }
const _hoisted_63 = { class: "fen" }

import AMapLoader from "@amap/amap-jsapi-loader";
import { onMounted } from "vue";
import { ref } from "vue";
import { useRouter, useRoute } from 'vue-router';
import * as echarts from 'echarts';
import myDialog from '@/views/entryDetailsPages/myDialog.vue'
import javaapi from "@/service/javaapi";
import { toRaw } from '@vue/reactivity'
import { da, fa } from "element-plus/es/locale";

type EChartsOption = echarts.EChartsOption

export default /*#__PURE__*/_defineComponent({
  __name: 'participatingInstitutions',
  setup(__props) {

const router = useRouter()
const activeName = ref("GISPage");
let map
let infoWindow
let lastPosition

const chartInfo = ref({
  projectId: 0,
  title2: '2022年3月政府考核项目',
  title1: '政府考核',
  name: '西安市应急管理局',
  score1: 0,
  score2: 0,
  number: 0,
  ongoingNum: 0,
  pauseNum: 0,
  completedNum: 0,

})

const activeButton = ref(0)

const getSubjects = async (index, subjectId) => {
  activeButton.value = index
  maxSchoolScore.value = subjectInfos.value[index].standard_score
  schoolTableData.value.length = 0
  for await (const data of areaScores.value) {
    //console.log("data", toRaw(data))
    const query = {
      jsonText: { "projectId": toRaw(data).id, "baseSubjectId": subjectId },
      token: localStorage.getItem('token'),
      user_id: localStorage.getItem('user_id'),
    }
    //console.log("query",query)
    var subjectScore = await javaapi.postQuery(query, "/subject/getSubjectScore");
    //console.log("subjectScore", subjectScore)
    let temp = {
      projectId: '',
      areaName: '',
      score: 0
    }
    temp.areaName = toRaw(data).name
    temp.projectId = toRaw(data).id
    if (subjectScore.status == 1)
      temp.score = subjectScore.data.score

    schoolTableData.value.push(temp)
  }


}

const areaScores = ref([
])

const schoolTableData = ref([
  {
    organization_id: '',
    areaName: '雁塔区',
    score: 8
  },
  {
    organization_id: '',
    areaName: '灞桥区',
    score: 12
  }
])

const maxSchoolScore = ref(20)
const dialogVisible = ref(false)
const dialogLoading = ref(false)
const maxNum = ref(0)
const route = useRoute()
const clickChart = async () => {
  dialogLoading.value = true
  subjectInfos.value.length = 0
  const query = {
    jsonText: { "organization_id": localStorage.getItem('organization_id'), "checkup_project_id": chartInfo.value.projectId },
    token: localStorage.getItem('token'),
    user_id: localStorage.getItem('user_id'),
  }
  const result = await javaapi.postQuery(query, '/subject/getSubjectInfo')
  //console.log('result', result)
  if (result.status == 1) {
    subjectInfos.value = [...result.data]
    //console.log(subjectInfos.value)
  }
  maxSchoolScore.value = subjectInfos.value[0].standard_score
  schoolTableData.value.length = 0
  for await (const data of areaScores.value) {
    console.log("data", toRaw(data))
    const query = {
      jsonText: { "projectId": toRaw(data).id, "baseSubjectId": subjectInfos.value[0].checkup_subject_id },
      token: localStorage.getItem('token'),
      user_id: localStorage.getItem('user_id'),
    }
    //console.log("query",query)
    var subjectScore = await javaapi.postQuery(query, "/subject/getSubjectScore");
    //console.log("subjectScore", subjectScore)
    let temp = {
      projectId: '',
      areaName: '',
      score: 0
    }
    temp.areaName = toRaw(data).name
    temp.projectId = toRaw(data).id
    if (subjectScore.status == 1)
      temp.score = subjectScore.data.score

    schoolTableData.value.push(temp)
  }

  //console.log(schoolTableData.value)
  dialogVisible.value = true
  dialogLoading.value = false
}
const subjectInfos = ref([{
  "checkup_subject_id": 0,
  "score": 0.0,
  "standard_score": 0.0,
  "checkup_subject_name": "",
  "completed_num": 0,
  "incomplete_num": 0,
  "completed_percentage": 0
},])
const px = ref(Math.min(window.outerHeight, window.outerWidth) * 0.3 * (1 / 3))
const init = async (percentage: number) => {
  var chartDom = document.getElementById('main12')!;
  var myChart = echarts.init(chartDom);
  var option: EChartsOption;
  const gaugeData = [
    {
      value: 20,
      name: 'Perfect',
      detail: {
        valueAnimation: true,
        offsetCenter: ['0%', '0%']
      }
    }
  ];
  option = {
    series: [
      {
        type: 'gauge',
        startAngle: 90,
        endAngle: -270,
        pointer: {
          show: false
        },
        radius: px.value / 2 - 2,
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {

            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
              // 四个数字分别对应 数组中颜色的开始位置，分别为 右，下，左，上。例如（1,0,0,0 ）代表从右边开始渐
              // 变。offset取值为0~1，0代表开始时的颜色，1代表结束时的颜色，柱子表现为这两种颜色的渐变。
              offset: 0,
              color: '#2B8EF3'
            }, {
              offset: 1,
              color: '#47E4E5'
            }]),
          }
        },
        axisLine: {
          lineStyle: {
            width: 10,
          }
        },
        splitLine: {
          show: false,
          distance: 0,
          length: 10
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false,
        },
        data: gaugeData,
        title: {
          show: false
        },
        detail: {
          fontSize: px.value / 4,
          color: '#fff',
          formatter: '{value}%',

        }
      }
    ]
  };
  gaugeData[0].value = percentage;
  myChart.setOption<EChartsOption>(option);
}

const dataInit = async (projectList) => {
  var selector = {
    ProjectId: parseInt(route.query.projectId + '')
  }
  maxNum.value = 0;
  // await javaapi.list({ entity: "project", interface: "getAllProjectsByProjectId" }, selector);
  projectList.project.forEach(async (val: any, idx: any, arr: any) => {
    var temp = {
      id: 0,
      name: '',
      score: 0,
      standard_score: 1,
      questionNum: 0
    }
    var selector1 = {
      ProjectId: val.checkupProjectId
    }
    var projectInfo = await javaapi.getEntity({ entity: "project", interface: "getAllProjectsDetailInfByProjectId" }, selector1);
    temp.id = projectInfo.id
    console.log("projectInfo", projectInfo)
    temp.name = projectInfo.organizationName
    temp.score = projectInfo.score
    temp.standard_score = projectInfo.standard_score
    temp.questionNum = await javaapi.getEntity({ entity: "project", interface: "getProblemNumByProjectId" }, selector1)
    areaScores.value.push(temp);
    if (temp.questionNum > maxNum.value) {
      maxNum.value = temp.questionNum
    }
  })


}

const initChart = async (id: number, projectList) => {
  var selector = {
    ProjectId: parseInt(route.query.projectId + '')
  }
  var selector1 = {
    ProjectId: id
  }
  // var projectList = await javaapi.list({ entity: "project", interface: "getAllProjectsByProjectId" }, selector);
  var projectInfo = await javaapi.getEntity({ entity: "project", interface: "getProjectsDetailInfByProjectId" }, selector);
  chartInfo.value.projectId = projectInfo.id
  chartInfo.value.name = projectInfo.organizationName
  chartInfo.value.title1 = projectInfo.type
  chartInfo.value.title2 = projectInfo.name
  chartInfo.value.score1 = projectInfo.score
  chartInfo.value.score2 = projectInfo.standard_score
  chartInfo.value.number = projectList.project.length
  var ongoingNum = 0
  var pauseNum = 0
  var completedNum = 0
  projectList.project.forEach(async (val: any, idx: any, arr: any) => {
    if (val.checkupProjectStatusId == 20001) {
      ongoingNum++;
    } else if (val.checkupProjectStatusId == 20002) {
      pauseNum++;
    } else if (val.checkupProjectStatusId == 30002) {
      completedNum++;
    }
  })
  chartInfo.value.ongoingNum = ongoingNum
  chartInfo.value.pauseNum = pauseNum
  chartInfo.value.completedNum = completedNum
}

const initMap = () => {
  AMapLoader.load({
    key: "6bbe90d8254c3cc452e1346bf9957d2e", // 开发者Key
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: [], // 需要使用的的插件列表
  })
    .then(async (AMap) => {
      var selector1 = {
        ProjectId: parseInt(route.query.projectId + ''),
        user_id: parseInt(<string>localStorage.getItem("user_id")),
      }
      var project = await javaapi.list({ entity: "project", interface: "getAllProjectsByProjectId" }, selector1);
      if(project.project.length === 0){
        project = await javaapi.list({ entity: "project", interface: "getAllProjectsByParentProjectId" }, selector1);
      }
      initChart(project.project[0].distributeOrganizationCheckupProjectId, project)
      dataInit(project)
      console.log(111111111);
      var projectInfo = await javaapi.getEntity({ entity: "project", interface: "getAllProjectsDetailInfByProjectId" }, selector1);

      
      map = new AMap.Map("container", {
        //设置地图容器id
        viewMode: "2D", //地图模式
        zoom: 12, //初始化地图级别
        center: [Number(projectInfo.longitude), Number(projectInfo.latitude)], //初始化地图中心点位置
        mapStyle: "amap://styles/darkblue",
      });


      project.project.forEach(async (val: any, idx: any, arr: any) => {
        var selector = {
          ProjectId: val.checkupProjectId
        }

        var icon = {
          type: "image",
          image: "static/mapLogo.png",
          anchor: "center",
        };
        var projectInfo = await javaapi.getEntity({ entity: "project", interface: "getAllProjectsDetailInfByProjectId" }, selector);
        //console.log(projectInfo)
        var tempDate = {
          id: projectInfo.id,
          organizationName: projectInfo.organizationName,
          projectName: projectInfo.name,
          rate: projectInfo.number === 0?0:projectInfo.completedNum / projectInfo.number * 100
        }
        
        
        let parentDepth = localStorage.getItem('currentDepth');
        console.log(projectInfo,parentDepth);
        if (val.organization_id == localStorage.getItem("organization_id")) {
          icon.image = "static/mapLogo1.png"
        } else if (projectInfo.depth - parentDepth == 1) {
          icon.image = "static/mapLogo2.png"
        } else if (projectInfo.depth - parentDepth == 2) {
          icon.image = "static/mapLogo3.png"
        } else {
          icon.image = "static/mapLogo4.png"
        }

        var labelMarker = new AMap.LabelMarker({
          name: "标注2",
          position: [Number(projectInfo.longitude), Number(projectInfo.latitude)],
          zIndex: 16,
          icon: icon,
          extData: tempDate,
        });

        var selector2 = {
          ProjectId: Number(projectInfo.id)
        }
        var problemNum = await javaapi.getEntity({ entity: "project", interface: "getProblemNumByProjectId" }, selector2);
        var expertNum = await javaapi.getEntity({ entity: "project", interface: "getExpertNumByProjectId" }, selector2);
        //console.log("problemNum", problemNum)
        if (projectInfo.charge_user == undefined) projectInfo.charge_user = '无';
        infoWindow = new AMap.InfoWindow({ isCustom: true, offset: new AMap.Pixel(450, 150) });
        labelMarker.content = '<svg width="615" height="380" opacity="1">\
          <circle cx="15" cy="230" r="14" stroke="#2D5BD9" stroke-width="1" fill="none" />\
          <circle cx="15" cy="230" r="6.5" fill="#2D5BD9" />\
          <polyline points="15,216 15,176 73,126" style="fill:none;stroke:#2D5BD9;stroke-width:1" />\
          <polygon points="73,0 73,380 294,380 304,370 404,370 414,380 615,380 615,0 415,0 405,10 283,10 273,0"\
              style="fill:rgba(13,54,168,0.5);stroke:#0E9CFF;stroke-width:1px" />\
        </svg>\
        <div style="font-size:34px;position: absolute;z-index: 100;top: 40px;left: 100px;width: 316px;text-wrap: nowrap;overflow: hidden;text-overflow: ellipsis;">'+ projectInfo.organizationName + '</div>\
        <div id="main12" style="width: 200px;height:200px;position: absolute;z-index: 99;top: 70px;left: 60px;">\
        </div>\
        <div style="font-size:20px;position: absolute;z-index: 99;top: 240px;left: 113px;">项目完成率</div>\
        <div id="labelButton" style="background:rgba(18,40,149);z-index:999;width: 220px;height: 44px;border:0;border-radius: 22px;\
        position: absolute;top: 300px;right: 150px;display: flex;align-items:center;justify-content: center;">\
          <span>查看项目详情</span>\
        </div>\
        <div style="position: absolute;left: 38%;top: 12%;">\
        <div class="score-layout" style="position: relative;width: 160px;height: 20%;left:180px;">\
            <div class="upline" style="position: absolute;width: 100%;height: 1px;opacity: 1;align-self: stretch;background: #6A8B9D;"></div>\
            <div class="content" style="position: absolute;top: 5%;width: 100%;height: 57%;">\
                <div class="score" style="position: absolute;top: 10%;width: 100%;font-size:26px;display:flex;justify-content: space-between;">\
                    <span class="score1">'+ projectInfo.score + '</span>\
                    <span class="score2">/</span>\
                    <span class="score3">'+ projectInfo.standard_score + '</span>\
                </div>\
                <div class="program-score" style="font-size:14px;position: absolute;top: 30px;width: 100%;color: #9BA3AA;display:flex;justify-content: space-between;">\
                    <span class="p1">项目得分</span>\
                    <span class="p2">项目标准分</span>\
                </div>\
            </div>\
            <div class="downline" style="position:absolute;top: 50px;width: 160px;height: 1px;align-self: stretch;background: #6A8B9D;"></div>\
        </div>\
        <div class="information" style="position: relative;top: 80px;font-size:18px;">\
            <div style="padding-bottom: 10px;">问题数量: '+ problemNum + '</div>\
            <div style="padding-bottom: 10px;">项目周期：'+ projectInfo.start_date + ' 至 ' + projectInfo.end_date + '</div>\
            <span style="padding-bottom: 10px;padding-right: 50px;">立项人：'+ projectInfo.added_user + '</span>\
            <span style="padding-bottom: 10px;">负责人：'+ projectInfo.charge_user + '</span>\
            <div style="padding-top: 10px;">专家数量：'+ expertNum + '</div>\
        </div>\
        </div>';
        labelMarker.on('click', createInfoWindow);
        var labelsLayer = new AMap.LabelsLayer({
          zooms: [3, 20],
          zIndex: 1000,
          collision: true,
          allowCollision: true,
        });

        labelsLayer.add(labelMarker);
        map.add(labelsLayer);
        var text = new AMap.Text({
          position: [Number(projectInfo.longitude), Number(projectInfo.latitude)],
          anchor: "button-left",
          offset: [30, -20],
          text: projectInfo.organizationName,
          style: {
            "font-size": "36px",
            color: "#fff",
            "font-family": "YouSheBiaoTiHei",
            "background-color": "transparent",
            border: "0px",
          },
        });
        text.on('click', createInfoWindow);
        map.add(text);
      })
      map.on('click', closeInfoWindow);
    })
    .catch((e) => {
      //console.log(e);
    });
};

const createInfoWindow = (e) => {
  infoWindow.setContent(e.target.content);
  infoWindow.open(map, e.target.getPosition());
  lastPosition = e.target.getPosition();
  console.log(e.target.getOptions());
  
  init(e.target.getOptions().extData.rate);
  var labelButton = document.getElementById("labelButton");
  if (labelButton) {
    labelButton.onclick = async function () {
      //TODO:跳转页面
      router.push({
        name: 'ChartDetail',
        query: {
          projectId: e.target.getOptions().extData.id,
          projectName: e.target.getOptions().extData.projectName,
          organizationName: e.target.getOptions().extData.organizationName,
          isFromProject: 0,
        },
      });
    }
  }
};

const back = () => {
  router.go(-1);
}

const closeInfoWindow = () => {
  infoWindow.close(map, lastPosition);
}

onMounted(() => {
  initMap();
});

return (_ctx: any,_cache: any) => {
  const _component_Back = _resolveComponent("Back")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!dialogVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_icon, {
                onClick: back,
                style: {"color":"white","font-size":"1.8vw","cursor":"pointer"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Back)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(chartInfo.value.title1) + "类", 1),
              _createVNode(_component_el_tooltip, {
                effect: "customized",
                content: chartInfo.value.title2,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(chartInfo.value.title2), 1)
                ]),
                _: 1
              }, 8, ["content"]),
              _createVNode(_component_el_tooltip, {
                effect: "customized",
                content: chartInfo.value.name,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(chartInfo.value.name), 1)
                ]),
                _: 1
              }, 8, ["content"]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(chartInfo.value.score1), 1),
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, _toDisplayString(chartInfo.value.score2), 1)
                  ]),
                  _hoisted_16
                ]),
                _hoisted_17
              ]),
              _createVNode(_component_el_col, {
                class: "thirdPart",
                span: 24,
                style: {"font-size":"24px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _createVNode(_component_el_row, {
                    gutter: 10,
                    style: {"font-size":"44px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(chartInfo.value.number), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"20px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("进行中")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"20px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("已暂停")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"20px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("已完成")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"24px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(chartInfo.value.ongoingNum), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"24px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(chartInfo.value.pauseNum), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 8,
                        style: {"font-size":"24px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(chartInfo.value.completedNum), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _withDirectives(_createElementVNode("div", {
            class: "leftButton",
            onClick: clickChart
          }, " 查看对比数据 ", 512), [
            [_vShow, !dialogLoading.value]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            "element-loading-background": "rgba(7, 27, 84, 0.3)",
            class: "leftButton",
            onClick: clickChart
          }, [
            _createTextVNode(" 加载数据中 ")
          ])), [
            [_vShow, dialogLoading.value],
            [_directive_loading, dialogLoading.value]
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(myDialog, {
      class: "myDialog",
      "dialog-visible": dialogVisible.value,
      onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = false))
    }, {
      content: _withCtx(() => [
        _createVNode(_component_el_tooltip, {
          effect: "customized",
          content: chartInfo.value.title2,
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, _toDisplayString(chartInfo.value.title2), 1)
          ]),
          _: 1
        }, 8, ["content"]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_tooltip, {
            effect: "customized",
            content: chartInfo.value.name,
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, _toDisplayString(chartInfo.value.name), 1)
            ]),
            _: 1
          }, 8, ["content"]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(chartInfo.value.score1), 1),
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, _toDisplayString(chartInfo.value.score2), 1)
              ]),
              _hoisted_29
            ]),
            _hoisted_30
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _hoisted_33,
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_el_scrollbar, {
              "max-height": "90%",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaScores.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_el_tooltip, {
                        effect: "customized",
                        content: item.name,
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_38, _toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", {
                            class: "progressBar",
                            style: _normalizeStyle('width:' + (item.score / item.standard_score) * 100 + '%;')
                          }, null, 4)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", null, _toDisplayString(item.score) + " ", 1),
                        _hoisted_42
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("span", null, _toDisplayString(item.questionNum) + " ", 1),
                        _hoisted_45
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", {
                            class: "progressBar",
                            style: _normalizeStyle('width:' + (maxNum.value == 0?0:(item.questionNum / maxNum.value * 100)) + '%;')
                          }, null, 4)
                        ])
                      ])
                    ])
                  ]))
                }), 256))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_el_scrollbar, { "max-height": "100%" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectInfos.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        effect: "customized",
                        content: item.checkup_subject_name,
                        placement: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(activeButton.value == index ? 'button-active' : 'button'),
                            onClick: ($event: any) => (getSubjects(index, item.checkup_subject_id))
                          }, _toDisplayString(item.checkup_subject_name), 11, _hoisted_51)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("div", _hoisted_55, _toDisplayString(maxSchoolScore.value), 1),
              _hoisted_56,
              _hoisted_57
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createVNode(_component_el_scrollbar, { "max-height": "100%" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolTableData.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", {
                            class: "progressBar",
                            style: _normalizeStyle('width:' + item.score / maxSchoolScore.value * 100 + '%;')
                          }, null, 4)
                        ])
                      ]),
                      _createVNode(_component_el_tooltip, {
                        effect: "customized",
                        content: item.areaName,
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_62, _toDisplayString(item.areaName) + "   ", 1)
                        ]),
                        _: 2
                      }, 1032, ["content"]),
                      _createElementVNode("div", _hoisted_63, _toDisplayString(item.score) + "分", 1)
                    ]))
                  }), 256))
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["dialog-visible"])
  ], 64))
}
}

})